import { observer } from "mobx-react";
import { OFTableController } from "../OFTableController";
import { translateKey as t } from "../../../locales/translation";
import numbro from "numbro";
import { Tag } from "antd";

const RenderFooter = observer(({ ofTableController }: { ofTableController: OFTableController }) => {
  // showTotals = false;

  const selectedRows = () => {
    return numbro(ofTableController.multiSelectedRows.totSelected).format({ thousandSeparated: true });
  };

  const renderSelectedRows = () => {
    return (
      <div style={{ padding: "5px 10px" }}>{t("lblMultiSelectedCount", "Multi-Selected ({1})", [selectedRows()])}</div>
    );
  };

  const { sortedFilteredList, tableData, props } = ofTableController;

  if (props?.showFooter === false || props?.compactMode) {
    return null;
  }

  const sortedData = numbro(sortedFilteredList.length).format({ thousandSeparated: true });
  const fullData = props?.pagination
    ? numbro(props.pagination.total).format({ thousandSeparated: true })
    : numbro(tableData.length).format({ thousandSeparated: true });

  return (
    <div className="tableFooter">
      <div className="footerStats">
        <div className="leftAlign">
          <div style={{ padding: "5px 10px" }} data-e2e="footer-stats-showing-x-of-y">
            {t("lblShowingCountOfCount", "Showing {1} of {2}", [sortedData, fullData])}
            {props?.pagination && props?.pagination?.hasMoreData && (
              <Tag className="ml-5" color="volcano">
                {t(
                  "lblPaginationLimitMessage",
                  "You are seeing the first {1} (max count) results only. Please refine your search in order to see more specific results",
                  [numbro(props.pagination.total).format({ thousandSeparated: true })]
                )}
              </Tag>
            )}
          </div>

          {props?.showCheckbox !== false && renderSelectedRows()}
        </div>
      </div>
    </div>
  );
});

export { RenderFooter };
